(function (overtimedeclaration, $) {

    overtimedeclaration.modes = [
        { index: 0, title: 'Toeslag uitbetalen' },
        { index: 1, title: 'Volledig uitbetalen' },
        { index: 2, title: 'Verlof' }
    ];

    /* Callback when declaration request submit failed */
    overtimedeclaration.submitFailed = (context) => {
        overtimedeclaration.hideSubmitSpinner();
        global.onFailure(context.responseJSON?.value);
    }

    /* Show the submit button */
    overtimedeclaration.showSubmitSpinner = function () {
        let button = $('[data-submit-button]');
        global.ShowButtonSpinner(button);
        global.DisableButton(button);
    }

    /* Hide the submit button */
    overtimedeclaration.hideSubmitSpinner = function () {
        let button = $('[data-submit-button]');
        global.HideButtonSpinner(button);
        global.EnableButton(button);
    }

    /* round time to nearest 15 minutes */
    overtimedeclaration.roundTime = function (value) {
        const localDateTime = new Date('1-1-2000 ' + value);
        const timezoneOffset = localDateTime.getTimezoneOffset();

        // Round minutes to the nearest 15
        const minutes = localDateTime.getMinutes();
        const roundedMinutes = Math.round(minutes / 15) * 15;
        localDateTime.setMinutes(roundedMinutes - timezoneOffset);
        localDateTime.setSeconds(0);
        localDateTime.setMilliseconds(0);

        return localDateTime.toISOString().slice(11, 16);
    }

    overtimedeclaration.init = function () {
        flatpickr.localize(dutch);

        let previous = $('[data-autosave-value]').val();
        $(document).on('change', '[data-autosave-value]', function () {
            let control = $(this);
            let contractId = $(this).val();

            $.ajax({
                url: '/OvertimeDeclaration/Home/UpdateDeclarationRequest',
                cache: false,
                method: 'POST',
                data: {
                    key: $('[data-key]').val(),
                    contractId: parseInt(contractId)
                },
                success: function (data) {
                    if (data.success == false) {
                        // Reset to previous value
                        control.val(previous);

                        $('#alertscontainer').empty();
                        global.ShowInfoAlert('#alertscontainer', 'Er is iets misgegaan bij het opslaan');
                        return;
                    }

                    if (previous != contractId) {
                        previous == contractId;
                    }

                }
            });
        });
    }

    /* Add Select2 to ProjectNumber select field */
    overtimedeclaration.InitSelect2 = function () {
        $.fn.select2.amd.require(['select2/selection/search'], function (Search) {
            var oldRemoveChoice = Search.prototype.searchRemoveChoice;

            Search.prototype.searchRemoveChoice = function () {
                oldRemoveChoice.apply(this, arguments);
                this.$search.val('');
            };

            $('[data-project]').select2({
                theme: 'bootstrap-5',
                dropdownParent: $('#modalcontent'),
                language: 'nl'
            });
        });

        var setFlatpickr = function (tag, isTime) {
            let selector = '[' + tag + ']';
            let $selector = $(selector);

            $('[' + tag + 'click]').flatpickr({
                dateFormat: (isTime ? "H:i" : "d-m-Y"),
                enableTime: isTime,
                noCalendar: isTime,
                minuteIncrement: 15,
                time_24hr: true,
                onOpen: function (selectedDates, dateStr, instance) {
                    if ($selector.val() != '')
                        instance.setDate($selector.val());
                    else if (isTime)
                        instance.setDate('12:00');
                    else
                        instance.setDate(Date.now());
                },
                onChange: function (selectedDates, dateStr, instance) {
                    if (isTime)
                        $selector.val(overtimedeclaration.roundTime(dateStr));
                    else
                        $selector.val(dateStr);
                }
            });

            $selector.on('change', function (e) {
                $selector.val(overtimedeclaration.roundTime($selector.val()));
            });
        };

        setFlatpickr("data-startdate", false);
        setFlatpickr("data-starttime", true);
        setFlatpickr("data-enddate", false);
        setFlatpickr("data-endtime", true);
    }

    overtimedeclaration.declarationRuleCountChanged = function (context) {
        global.onModalSuccess(context, function () {
            $('[data-contract-id]').prop('disabled', $('#declarationrulesgrid table>tbody>tr').length > 0);
        });
    }

    overtimedeclaration.initDeclarationRulesTable = function (declarationRequestKey, hasRosterHours) {
        var table = $('#declarationrulestable').DataTable(datatable.defaultDatatableOptions({
            ajax: {
                url: '/OvertimeDeclaration/Home/SearchDeclarationRules',
                data: {
                    declarationRequestKey: declarationRequestKey
                }
            },
            orderFixed: {
                name: 'start',
                dir: 'asc'
            },
            searchable: false,
            info: false,
            paging: false,
            columns: [
                { data: 'start', name: 'Start', title: 'Begin', sortable: true, searchable: false },
                { data: 'end', name: 'End', title: 'Eind', sortable: false, searchable: false },
                { data: 'mode', name: 'Mode', title: 'Soort vergoeding', sortable: false, searchable: false, enum: overtimedeclaration.modes },
                { data: 'reason', name: 'Reason', title: 'Reden', sortable: false, searchable: false },
                { responsivePriority: -1, defaultContent: '', orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: [0, 1],
                    width: '15%',
                    render: function (data, type, full, meta) {
                        return datatable.dutchDateFormat(data, hasRosterHours ? 'DD-MM-YYYY' : 'DD-MM-YYYY HH:mm')
                    }
                },
                {
                    targets: [2],
                    width: '20%'
                },
                {
                    targets: [3],
                    width: '35%'
                },
                {
                    target: -1,
                    width: '10%',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        let aHrefs = [
                            `<a data-bs-toggle='modal' data-bs-target='#modalcontainer' class='btn btn-datatable btn-outline-primary fas fa-trash-alt' title='Verwijderen' href='/OvertimeDeclaration/Home/DeleteDeclarationRule?declarationRequestKey=${declarationRequestKey}&amp;declarationRuleKey=${full.key}'></a>`,
                            `<a data-bs-toggle='modal' data-bs-target='#modalcontainer' class='btn btn-datatable btn-outline-primary fas fa-edit' title='Wijzigen' href='/OvertimeDeclaration/Home/EditDeclarationRule?declarationRequestKey=${declarationRequestKey}&amp;declarationRuleKey=${full.key}'></a>`];
                        return aHrefs.join('\n');
                    }
                }
            ]
        }));
        var columnHeader = table.column(-1).header();
        $(columnHeader).html(`<a data-bs-toggle='modal' data-bs-target='#modalcontainer' class='btn btn-datatable btn-outline-primary fas fa-plus' title='Toevoegen' href='/OvertimeDeclaration/Home/CreateDeclarationRule?declarationRequestKey=${declarationRequestKey}'></a>`);

        table.on('processing.dt', function (e, settings, processing) {
            if (settings._iRecordsTotal > 0)
                $("[data-contract-id]").attr("disabled", "disabled");
            else
                $("[data-contract-id]").removeAttr("disabled");
        });
    }

    overtimedeclaration.initDeclarationResultsTable = function (subscriptionKey, declarationRequestKey, hasRosterHours) {
        var bindOnClicks = function () {
            $('[data-declarationResultModalButton]').on('click', function () {
                var modalData = $(this).next('[data-declarationResultModal]');
                $('#modalcontainer .modal-content').html(modalData.html());
                $('#modalcontainer').modal('show');
                $('#modal fade').attr('class', 'second');
            });
        };

        var table = $('#declarationresultstable').DataTable(datatable.defaultDatatableOptions({
            ajax: {
                url: '/OvertimeDeclaration/Home/SearchDeclarationResults',
                data: {
                    subscriptionKey: subscriptionKey,
                    declarationRequestKey: declarationRequestKey
                }
            },
            searchable: false,
            info: false,
            paging: false,
            columns: [
                { data: 'displayTotalDuration', name: 'DisplayTotalDuration', title: 'Aantal uren', sortable: true, searchable: false },
                { data: 'mode', name: 'Mode', title: 'Soort vergoeding', sortable: false, searchable: false, enum: overtimedeclaration.modes },
                { data: 'displayPercentage', name: 'DisplayPercentage', title: 'Percentage', sortable: false, searchable: false },
                { data: 'displayLeave', name: 'DisplayLeave', title: 'Verlof', sortable: false, searchable: false },
                { data: 'displayPaidOut', name: 'DisplayPaidOut', title: 'Uitbetalen', sortable: false, searchable: false },
                { responsivePriority: -1, defaultContent: '', orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: [0, 1, 3, 4],
                    width: '20%'
                },
                {
                    targets: 2,
                    width: '20%',
                    render: function (data, type, full, meta) {
                        return `${data}%`;
                    }
                },
                {
                    target: -1,
                    width: '10%',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        let modalTemplate = document.getElementById('declaration-result-modal-template');
                        let modal = modalTemplate.content.cloneNode(true);
                        let headerTemplate = document.getElementById('begin-end-header-template');
                        let rowTemplate = document.getElementById('declaration-result-row-template');
                        let tbody = modal.querySelector('tbody');

                        if (!hasRosterHours) {
                            let beginEndHeaders = headerTemplate.content.cloneNode(true);
                            let firstHeader = modal.querySelector('thead>tr>th:nth-child(2)');
                            firstHeader.parentElement.insertBefore(beginEndHeaders, firstHeader);
                        }

                        full.results.forEach((result) => {
                            let createTd = function (node) {
                                let td = document.createElement('td');
                                td.append(node);
                                tr.appendChild(td);
                            }

                            let row = rowTemplate.content.cloneNode(true);
                            let tr = row.querySelector('tr');
                            createTd(datatable.dutchDateFormat(result.start, 'DD-MM-YYYY'));
                            if (!hasRosterHours) {
                                createTd(datatable.dutchDateFormat(result.start, 'HH:mm'));
                                createTd(datatable.dutchDateFormat(result.end, 'HH:mm'));
                            }
                            createTd(result.displayDuration);
                            createTd(overtimedeclaration.modes.find(mode => mode.index === full.mode).title);
                            createTd(`${full.displayPercentage}%`);
                            createTd(result.displayLeave);
                            createTd(result.displayPaidOut);
                            tbody.appendChild(row);
                        });
                        let button = document.createElement('button');
                        button.classList.add('btn', 'btn-datatable', 'btn-primary');
                        button.setAttribute('type', 'button');
                        button.setAttribute('data-declarationResultModalButton', '');
                        button.innerHTML = 'Details';
                        let div = document.createElement('div');
                        div.setAttribute('hidden', '');
                        div.setAttribute('data-declarationresultmodal', '');
                        div.setAttribute('data-manualmodal', '');
                        div.appendChild(modal);
                        return `${button.outerHTML}\n${div.outerHTML}`;
                    }
                }
            ]
        }));

        table.on('draw', function () {
            $('button[type=\'submit\'][name=\'Action\']').prop('disabled', table.rows().count() == 0);

            bindOnClicks();
        });
    }


}(window.overtimedeclaration = window.overtimedeclaration || {}, $));

var dutch = {
    weekdays: {
        shorthand: ["zo", "ma", "di", "wo", "do", "vr", "za"],
        longhand: [
            "zondag",
            "maandag",
            "dinsdag",
            "woensdag",
            "donderdag",
            "vrijdag",
            "zaterdag",
        ],
    },
    months: {
        shorthand: [
            "jan",
            "feb",
            "mrt",
            "apr",
            "mei",
            "jun",
            "jul",
            "aug",
            "sept",
            "okt",
            "nov",
            "dec",
        ],
        longhand: [
            "januari",
            "februari",
            "maart",
            "april",
            "mei",
            "juni",
            "juli",
            "augustus",
            "september",
            "oktober",
            "november",
            "december",
        ],
    },
    firstDayOfWeek: 1,
    weekAbbreviation: "wk",
    rangeSeparator: " t/m ",
    scrollTitle: "Scroll voor volgende / vorige",
    toggleTitle: "Klik om te wisselen",
    time_24hr: true,
    ordinal: function (nth) {
        if (nth === 1 || nth === 8 || nth >= 20)
            return "ste";
        return "de";
    },
};
